import React, { useState, useEffect } from 'react';
import Modal from '@app/react-common/components/modal/Modal';
import Button from '@app/react-common/components/button/Button';
import { Checkout } from '../../../models/Checkout';
import { Checkbox } from '@app/react-common/components/checkbox/Checkbox';

interface DuplicateMethodToAnotherCheckoutGroupModal {
  isOpen: boolean;
  onClose: () => void;
  checkouts: Checkout[];
  onSuccess: (selectedIds: number[]) => void;
  deliveryMethodName: string;
}

export const DuplicateMethodToAnotherCheckoutGroupModal: React.FC<DuplicateMethodToAnotherCheckoutGroupModal> = ({
  checkouts,
  isOpen,
  onClose,
  onSuccess,
  deliveryMethodName,
}) => {
  const [checkoutGroupsIds, setCheckoutGroupIds] = useState<number[]>([]);

  useEffect(() => {
    if (!isOpen) {
      setCheckoutGroupIds([]);
    }
  }, [isOpen]);

  const handleCheckboxChange = (id: number, checked: boolean) => {
    setCheckoutGroupIds((prev) => (checked ? [...prev, id] : prev.filter((item) => item !== id)));
  };

  const handleConfirm = () => {
    onSuccess(checkoutGroupsIds);
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="duplicate-method-to-another-checkout-modal">
        <h2 className="duplicate-method-to-another-checkout-modal__title">Duplicate to</h2>
        <div className="duplicate-method-to-another-checkout-modal__body">
          <a>Please select where you want to duplicate {deliveryMethodName || 'the shipping method'}</a>
          {checkouts.length > 0 ? (
            checkouts.map((checkout) => (
              <div key={checkout.id} className="duplicate-method-to-another-checkout-modal__checkbox">
                <Checkbox
                  label={checkout.name}
                  checked={checkoutGroupsIds.includes(checkout.id)}
                  onChange={(checked) => handleCheckboxChange(checkout.id, checked)}
                />
              </div>
            ))
          ) : (
            <p> No checkout group available to copy the shipping method to </p>
          )}
        </div>
        <div className="duplicate-method-to-another-checkout-modal__divider"></div>
        <div className="duplicate-method-to-another-checkout-modal__actions">
          <Button onClick={onClose} text="Cancel" size="medium" variant="secondary" />
          <Button
            onClick={handleConfirm}
            text="Confirm"
            size="medium"
            variant="primary"
            disabled={!checkoutGroupsIds.length}
          />
        </div>
      </div>
    </Modal>
  );
};
